import { SchemaError, TypedError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export class SchemaElementExcludesError extends SchemaError {
  static override locales: Locales = {
    'en-US': '%s type %s is in the excluded list',
    'zh-CN': '%s 的类型 %s 不在排除列表之外',
    'zh-HK': '%s 的類型 %s 不在排除列表之外'
  }

  override name = 'SchemaElementExcludesError' as const

  constructor(field = 'anonymous', excludeType: string) {
    super(field, excludeType)
  }
}

export class SchemaElementIncludesError extends SchemaError {
  static override locales: Locales = {
    'en-US': '%s type %s is not in the included list',
    'zh-CN': '%s 的类型 %s 不在包含列表之内',
    'zh-HK': '%s 的類型 %s 不在包含列表之內'
  }

  override name = 'SchemaElementIncludesError' as const

  constructor(field = 'anonymous', includeType: string) {
    super(field, includeType)
  }
}

export function registerElementErrorsSideEffect() {
  TypedError.registerErrorLocales({
    SchemaElementExcludesError,
    SchemaElementIncludesError
  })
}

registerElementErrorsSideEffect()
